import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { login, logout } from "@/lib/api";

export default function Navbar() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setUser(null);
    navigate("/");
  };

  const linkCls = ({ isActive }) =>
    `text-sm transition-colors ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#080A11]/75 border-b border-slate-800/80">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-blue-500 flex items-center justify-center shadow-lg shadow-violet-500/25">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <span className="font-display font-extrabold text-lg tracking-tight text-white">
            RevenueFix<span className="text-violet-400">.ai</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" data-testid="nav-link-home" end className={linkCls}>Accueil</NavLink>
          <NavLink to="/analyze" data-testid="nav-link-analyze" className={linkCls}>Analyser</NavLink>
          <NavLink to="/pricing" data-testid="nav-link-pricing" className={linkCls}>Pricing</NavLink>
          {user && <NavLink to="/dashboard" data-testid="nav-link-dashboard" className={linkCls}>Dashboard</NavLink>}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 text-sm text-slate-300">
                {user.picture && <img src={user.picture} alt="" className="w-7 h-7 rounded-full ring-2 ring-violet-500/30" />}
                <span className="font-medium">{user.name?.split(" ")[0] || user.email}</span>
                {user.plan !== "free" && (
                  <span className="ml-1 text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full bg-violet-500/20 text-violet-300 border border-violet-500/30">
                    {user.plan}
                  </span>
                )}
              </div>
              <Button
                data-testid="nav-logout-btn"
                onClick={handleLogout}
                variant="ghost"
                size="sm"
                className="text-slate-400 hover:text-white hover:bg-slate-800/60"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button
              data-testid="nav-auth-button"
              onClick={login}
              className="bg-gradient-to-r from-violet-600 to-blue-600 hover:from-violet-500 hover:to-blue-500 text-white shadow-lg shadow-violet-600/25 border-0"
            >
              Se connecter
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
